'use strict';

var cov_2gk9rxuhw8 = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\results_frame\\resultframeCtrl.js',
      hash = '94cf9731bfb4b8076817898cadbee961b12b53a1',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\results_frame\\resultframeCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 0
        },
        end: {
          line: 378,
          column: 3
        }
      },
      '1': {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 37
        }
      },
      '2': {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 8,
          column: 3
        }
      },
      '3': {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 11
        }
      },
      '4': {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 39
        }
      },
      '5': {
        start: {
          line: 11,
          column: 15
        },
        end: {
          line: 11,
          column: 28
        }
      },
      '6': {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 31,
          column: 4
        }
      },
      '7': {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 15,
          column: 5
        }
      },
      '8': {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 21
        }
      },
      '9': {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 18,
          column: 5
        }
      },
      '10': {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 17,
          column: 21
        }
      },
      '11': {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 22,
          column: 5
        }
      },
      '12': {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 22
        }
      },
      '13': {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 25,
          column: 5
        }
      },
      '14': {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 22
        }
      },
      '15': {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 29,
          column: 5
        }
      },
      '16': {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 22
        }
      },
      '17': {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 19
        }
      },
      '18': {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 351,
          column: 4
        }
      },
      '19': {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 79,
          column: 21
        }
      },
      '20': {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 84,
          column: 7
        }
      },
      '21': {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 21
        }
      },
      '22': {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 87,
          column: 7
        }
      },
      '23': {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 86,
          column: 21
        }
      },
      '24': {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 90,
          column: 7
        }
      },
      '25': {
        start: {
          line: 89,
          column: 8
        },
        end: {
          line: 89,
          column: 21
        }
      },
      '26': {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 93,
          column: 7
        }
      },
      '27': {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 92,
          column: 21
        }
      },
      '28': {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 99,
          column: 7
        }
      },
      '29': {
        start: {
          line: 95,
          column: 19
        },
        end: {
          line: 95,
          column: 63
        }
      },
      '30': {
        start: {
          line: 96,
          column: 8
        },
        end: {
          line: 98,
          column: 9
        }
      },
      '31': {
        start: {
          line: 97,
          column: 10
        },
        end: {
          line: 97,
          column: 23
        }
      },
      '32': {
        start: {
          line: 100,
          column: 6
        },
        end: {
          line: 100,
          column: 18
        }
      },
      '33': {
        start: {
          line: 103,
          column: 20
        },
        end: {
          line: 103,
          column: 43
        }
      },
      '34': {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 134,
          column: 8
        }
      },
      '35': {
        start: {
          line: 136,
          column: 6
        },
        end: {
          line: 157,
          column: 8
        }
      },
      '36': {
        start: {
          line: 159,
          column: 6
        },
        end: {
          line: 195,
          column: 8
        }
      },
      '37': {
        start: {
          line: 198,
          column: 6
        },
        end: {
          line: 198,
          column: 38
        }
      },
      '38': {
        start: {
          line: 199,
          column: 6
        },
        end: {
          line: 199,
          column: 28
        }
      },
      '39': {
        start: {
          line: 200,
          column: 6
        },
        end: {
          line: 200,
          column: 22
        }
      },
      '40': {
        start: {
          line: 201,
          column: 6
        },
        end: {
          line: 201,
          column: 28
        }
      },
      '41': {
        start: {
          line: 202,
          column: 6
        },
        end: {
          line: 202,
          column: 28
        }
      },
      '42': {
        start: {
          line: 203,
          column: 6
        },
        end: {
          line: 229,
          column: 9
        }
      },
      '43': {
        start: {
          line: 204,
          column: 22
        },
        end: {
          line: 204,
          column: 31
        }
      },
      '44': {
        start: {
          line: 205,
          column: 8
        },
        end: {
          line: 215,
          column: 9
        }
      },
      '45': {
        start: {
          line: 206,
          column: 10
        },
        end: {
          line: 214,
          column: 11
        }
      },
      '46': {
        start: {
          line: 207,
          column: 12
        },
        end: {
          line: 213,
          column: 13
        }
      },
      '47': {
        start: {
          line: 208,
          column: 14
        },
        end: {
          line: 210,
          column: 15
        }
      },
      '48': {
        start: {
          line: 209,
          column: 16
        },
        end: {
          line: 209,
          column: 50
        }
      },
      '49': {
        start: {
          line: 212,
          column: 14
        },
        end: {
          line: 212,
          column: 23
        }
      },
      '50': {
        start: {
          line: 216,
          column: 8
        },
        end: {
          line: 216,
          column: 45
        }
      },
      '51': {
        start: {
          line: 218,
          column: 8
        },
        end: {
          line: 226,
          column: 9
        }
      },
      '52': {
        start: {
          line: 219,
          column: 10
        },
        end: {
          line: 225,
          column: 11
        }
      },
      '53': {
        start: {
          line: 220,
          column: 12
        },
        end: {
          line: 220,
          column: 59
        }
      },
      '54': {
        start: {
          line: 221,
          column: 12
        },
        end: {
          line: 221,
          column: 59
        }
      },
      '55': {
        start: {
          line: 222,
          column: 12
        },
        end: {
          line: 224,
          column: 13
        }
      },
      '56': {
        start: {
          line: 223,
          column: 14
        },
        end: {
          line: 223,
          column: 72
        }
      },
      '57': {
        start: {
          line: 228,
          column: 8
        },
        end: {
          line: 228,
          column: 39
        }
      },
      '58': {
        start: {
          line: 232,
          column: 6
        },
        end: {
          line: 232,
          column: 65
        }
      },
      '59': {
        start: {
          line: 236,
          column: 6
        },
        end: {
          line: 239,
          column: 7
        }
      },
      '60': {
        start: {
          line: 237,
          column: 8
        },
        end: {
          line: 237,
          column: 30
        }
      },
      '61': {
        start: {
          line: 238,
          column: 8
        },
        end: {
          line: 238,
          column: 15
        }
      },
      '62': {
        start: {
          line: 240,
          column: 6
        },
        end: {
          line: 240,
          column: 31
        }
      },
      '63': {
        start: {
          line: 242,
          column: 20
        },
        end: {
          line: 242,
          column: 27
        }
      },
      '64': {
        start: {
          line: 243,
          column: 18
        },
        end: {
          line: 243,
          column: 25
        }
      },
      '65': {
        start: {
          line: 244,
          column: 6
        },
        end: {
          line: 244,
          column: 25
        }
      },
      '66': {
        start: {
          line: 246,
          column: 6
        },
        end: {
          line: 246,
          column: 66
        }
      },
      '67': {
        start: {
          line: 247,
          column: 6
        },
        end: {
          line: 255,
          column: 7
        }
      },
      '68': {
        start: {
          line: 248,
          column: 8
        },
        end: {
          line: 248,
          column: 50
        }
      },
      '69': {
        start: {
          line: 249,
          column: 8
        },
        end: {
          line: 249,
          column: 74
        }
      },
      '70': {
        start: {
          line: 251,
          column: 8
        },
        end: {
          line: 251,
          column: 87
        }
      },
      '71': {
        start: {
          line: 252,
          column: 8
        },
        end: {
          line: 252,
          column: 81
        }
      },
      '72': {
        start: {
          line: 254,
          column: 8
        },
        end: {
          line: 254,
          column: 52
        }
      },
      '73': {
        start: {
          line: 256,
          column: 6
        },
        end: {
          line: 256,
          column: 88
        }
      },
      '74': {
        start: {
          line: 257,
          column: 6
        },
        end: {
          line: 257,
          column: 102
        }
      },
      '75': {
        start: {
          line: 262,
          column: 8
        },
        end: {
          line: 268,
          column: 10
        }
      },
      '76': {
        start: {
          line: 271,
          column: 8
        },
        end: {
          line: 271,
          column: 35
        }
      },
      '77': {
        start: {
          line: 272,
          column: 8
        },
        end: {
          line: 272,
          column: 30
        }
      },
      '78': {
        start: {
          line: 273,
          column: 8
        },
        end: {
          line: 276,
          column: 9
        }
      },
      '79': {
        start: {
          line: 274,
          column: 10
        },
        end: {
          line: 274,
          column: 44
        }
      },
      '80': {
        start: {
          line: 275,
          column: 10
        },
        end: {
          line: 275,
          column: 42
        }
      },
      '81': {
        start: {
          line: 277,
          column: 8
        },
        end: {
          line: 279,
          column: 9
        }
      },
      '82': {
        start: {
          line: 278,
          column: 10
        },
        end: {
          line: 278,
          column: 44
        }
      },
      '83': {
        start: {
          line: 282,
          column: 21
        },
        end: {
          line: 282,
          column: 23
        }
      },
      '84': {
        start: {
          line: 283,
          column: 8
        },
        end: {
          line: 285,
          column: 9
        }
      },
      '85': {
        start: {
          line: 284,
          column: 10
        },
        end: {
          line: 284,
          column: 38
        }
      },
      '86': {
        start: {
          line: 287,
          column: 8
        },
        end: {
          line: 287,
          column: 20
        }
      },
      '87': {
        start: {
          line: 290,
          column: 21
        },
        end: {
          line: 290,
          column: 23
        }
      },
      '88': {
        start: {
          line: 291,
          column: 8
        },
        end: {
          line: 293,
          column: 9
        }
      },
      '89': {
        start: {
          line: 292,
          column: 10
        },
        end: {
          line: 292,
          column: 39
        }
      },
      '90': {
        start: {
          line: 294,
          column: 8
        },
        end: {
          line: 294,
          column: 20
        }
      },
      '91': {
        start: {
          line: 297,
          column: 21
        },
        end: {
          line: 297,
          column: 23
        }
      },
      '92': {
        start: {
          line: 298,
          column: 8
        },
        end: {
          line: 300,
          column: 9
        }
      },
      '93': {
        start: {
          line: 299,
          column: 10
        },
        end: {
          line: 299,
          column: 45
        }
      },
      '94': {
        start: {
          line: 301,
          column: 8
        },
        end: {
          line: 301,
          column: 20
        }
      },
      '95': {
        start: {
          line: 304,
          column: 8
        },
        end: {
          line: 336,
          column: 10
        }
      },
      '96': {
        start: {
          line: 314,
          column: 26
        },
        end: {
          line: 314,
          column: 40
        }
      },
      '97': {
        start: {
          line: 315,
          column: 14
        },
        end: {
          line: 315,
          column: 39
        }
      },
      '98': {
        start: {
          line: 316,
          column: 14
        },
        end: {
          line: 316,
          column: 42
        }
      },
      '99': {
        start: {
          line: 317,
          column: 30
        },
        end: {
          line: 317,
          column: 77
        }
      },
      '100': {
        start: {
          line: 318,
          column: 14
        },
        end: {
          line: 318,
          column: 40
        }
      },
      '101': {
        start: {
          line: 319,
          column: 14
        },
        end: {
          line: 325,
          column: 15
        }
      },
      '102': {
        start: {
          line: 320,
          column: 38
        },
        end: {
          line: 320,
          column: 60
        }
      },
      '103': {
        start: {
          line: 321,
          column: 16
        },
        end: {
          line: 323,
          column: 19
        }
      },
      '104': {
        start: {
          line: 322,
          column: 18
        },
        end: {
          line: 322,
          column: 123
        }
      },
      '105': {
        start: {
          line: 324,
          column: 16
        },
        end: {
          line: 324,
          column: 22
        }
      },
      '106': {
        start: {
          line: 339,
          column: 8
        },
        end: {
          line: 348,
          column: 11
        }
      },
      '107': {
        start: {
          line: 353,
          column: 2
        },
        end: {
          line: 376,
          column: 5
        }
      },
      '108': {
        start: {
          line: 354,
          column: 4
        },
        end: {
          line: 374,
          column: 51
        }
      },
      '109': {
        start: {
          line: 375,
          column: 4
        },
        end: {
          line: 375,
          column: 113
        }
      },
      '110': {
        start: {
          line: 377,
          column: 2
        },
        end: {
          line: 377,
          column: 31
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 4,
            column: 53
          },
          end: {
            line: 4,
            column: 54
          }
        },
        loc: {
          start: {
            line: 4,
            column: 150
          },
          end: {
            line: 378,
            column: 1
          }
        },
        line: 4
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 12,
            column: 30
          },
          end: {
            line: 12,
            column: 31
          }
        },
        loc: {
          start: {
            line: 12,
            column: 46
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 12
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 203,
            column: 74
          },
          end: {
            line: 203,
            column: 75
          }
        },
        loc: {
          start: {
            line: 203,
            column: 82
          },
          end: {
            line: 229,
            column: 7
          }
        },
        line: 203
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 321,
            column: 43
          },
          end: {
            line: 321,
            column: 44
          }
        },
        loc: {
          start: {
            line: 321,
            column: 48
          },
          end: {
            line: 323,
            column: 17
          }
        },
        line: 321
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 353,
            column: 45
          },
          end: {
            line: 353,
            column: 46
          }
        },
        loc: {
          start: {
            line: 353,
            column: 51
          },
          end: {
            line: 376,
            column: 3
          }
        },
        line: 353
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        }, {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        }],
        line: 6
      },
      '1': {
        loc: {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        }, {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        }],
        line: 13
      },
      '2': {
        loc: {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        }, {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        }],
        line: 16
      },
      '3': {
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        }, {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        }],
        line: 20
      },
      '4': {
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        }, {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        }],
        line: 23
      },
      '5': {
        loc: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 29,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 29,
            column: 5
          }
        }, {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 29,
            column: 5
          }
        }],
        line: 27
      },
      '6': {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 84,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 84,
            column: 7
          }
        }, {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 84,
            column: 7
          }
        }],
        line: 82
      },
      '7': {
        loc: {
          start: {
            line: 82,
            column: 10
          },
          end: {
            line: 82,
            column: 91
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 82,
            column: 10
          },
          end: {
            line: 82,
            column: 45
          }
        }, {
          start: {
            line: 82,
            column: 49
          },
          end: {
            line: 82,
            column: 91
          }
        }],
        line: 82
      },
      '8': {
        loc: {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 87,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 87,
            column: 7
          }
        }, {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 87,
            column: 7
          }
        }],
        line: 85
      },
      '9': {
        loc: {
          start: {
            line: 85,
            column: 10
          },
          end: {
            line: 85,
            column: 63
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 85,
            column: 10
          },
          end: {
            line: 85,
            column: 47
          }
        }, {
          start: {
            line: 85,
            column: 51
          },
          end: {
            line: 85,
            column: 63
          }
        }],
        line: 85
      },
      '10': {
        loc: {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 90,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 90,
            column: 7
          }
        }, {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 90,
            column: 7
          }
        }],
        line: 88
      },
      '11': {
        loc: {
          start: {
            line: 88,
            column: 10
          },
          end: {
            line: 88,
            column: 63
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 88,
            column: 10
          },
          end: {
            line: 88,
            column: 47
          }
        }, {
          start: {
            line: 88,
            column: 51
          },
          end: {
            line: 88,
            column: 63
          }
        }],
        line: 88
      },
      '12': {
        loc: {
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 93,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 93,
            column: 7
          }
        }, {
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 93,
            column: 7
          }
        }],
        line: 91
      },
      '13': {
        loc: {
          start: {
            line: 91,
            column: 10
          },
          end: {
            line: 91,
            column: 63
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 91,
            column: 10
          },
          end: {
            line: 91,
            column: 46
          }
        }, {
          start: {
            line: 91,
            column: 50
          },
          end: {
            line: 91,
            column: 63
          }
        }],
        line: 91
      },
      '14': {
        loc: {
          start: {
            line: 94,
            column: 6
          },
          end: {
            line: 99,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 94,
            column: 6
          },
          end: {
            line: 99,
            column: 7
          }
        }, {
          start: {
            line: 94,
            column: 6
          },
          end: {
            line: 99,
            column: 7
          }
        }],
        line: 94
      },
      '15': {
        loc: {
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        }, {
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        }],
        line: 96
      },
      '16': {
        loc: {
          start: {
            line: 198,
            column: 22
          },
          end: {
            line: 198,
            column: 37
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 198,
            column: 22
          },
          end: {
            line: 198,
            column: 26
          }
        }, {
          start: {
            line: 198,
            column: 30
          },
          end: {
            line: 198,
            column: 37
          }
        }],
        line: 198
      },
      '17': {
        loc: {
          start: {
            line: 205,
            column: 8
          },
          end: {
            line: 215,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 205,
            column: 8
          },
          end: {
            line: 215,
            column: 9
          }
        }, {
          start: {
            line: 205,
            column: 8
          },
          end: {
            line: 215,
            column: 9
          }
        }],
        line: 205
      },
      '18': {
        loc: {
          start: {
            line: 208,
            column: 14
          },
          end: {
            line: 210,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 208,
            column: 14
          },
          end: {
            line: 210,
            column: 15
          }
        }, {
          start: {
            line: 208,
            column: 14
          },
          end: {
            line: 210,
            column: 15
          }
        }],
        line: 208
      },
      '19': {
        loc: {
          start: {
            line: 219,
            column: 10
          },
          end: {
            line: 225,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 219,
            column: 10
          },
          end: {
            line: 225,
            column: 11
          }
        }, {
          start: {
            line: 219,
            column: 10
          },
          end: {
            line: 225,
            column: 11
          }
        }],
        line: 219
      },
      '20': {
        loc: {
          start: {
            line: 219,
            column: 14
          },
          end: {
            line: 219,
            column: 36
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 219,
            column: 14
          },
          end: {
            line: 219,
            column: 23
          }
        }, {
          start: {
            line: 219,
            column: 27
          },
          end: {
            line: 219,
            column: 36
          }
        }],
        line: 219
      },
      '21': {
        loc: {
          start: {
            line: 236,
            column: 6
          },
          end: {
            line: 239,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 236,
            column: 6
          },
          end: {
            line: 239,
            column: 7
          }
        }, {
          start: {
            line: 236,
            column: 6
          },
          end: {
            line: 239,
            column: 7
          }
        }],
        line: 236
      },
      '22': {
        loc: {
          start: {
            line: 249,
            column: 45
          },
          end: {
            line: 249,
            column: 72
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 249,
            column: 45
          },
          end: {
            line: 249,
            column: 59
          }
        }, {
          start: {
            line: 249,
            column: 63
          },
          end: {
            line: 249,
            column: 72
          }
        }],
        line: 249
      },
      '23': {
        loc: {
          start: {
            line: 251,
            column: 52
          },
          end: {
            line: 251,
            column: 85
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 251,
            column: 52
          },
          end: {
            line: 251,
            column: 72
          }
        }, {
          start: {
            line: 251,
            column: 76
          },
          end: {
            line: 251,
            column: 85
          }
        }],
        line: 251
      },
      '24': {
        loc: {
          start: {
            line: 252,
            column: 52
          },
          end: {
            line: 252,
            column: 79
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 252,
            column: 52
          },
          end: {
            line: 252,
            column: 66
          }
        }, {
          start: {
            line: 252,
            column: 70
          },
          end: {
            line: 252,
            column: 79
          }
        }],
        line: 252
      },
      '25': {
        loc: {
          start: {
            line: 317,
            column: 62
          },
          end: {
            line: 317,
            column: 76
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 317,
            column: 71
          },
          end: {
            line: 317,
            column: 72
          }
        }, {
          start: {
            line: 317,
            column: 75
          },
          end: {
            line: 317,
            column: 76
          }
        }],
        line: 317
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2gk9rxuhw8.s[0]++;
/**
* Result Frame  - controller
*/
angular.module('app').controller('result_frameCtrl', function ($scope, $deltaLocation, $rootScope, $CRUDService, $deltaTypeIndicateur, $filter, $translate) {
  cov_2gk9rxuhw8.f[0]++;
  cov_2gk9rxuhw8.s[1]++;

  $rootScope.processPageRight('3_3');
  cov_2gk9rxuhw8.s[2]++;
  if ($rootScope.global_access_page_denied) {
    cov_2gk9rxuhw8.b[0][0]++;
    cov_2gk9rxuhw8.s[3]++;

    return;
  } else {
    cov_2gk9rxuhw8.b[0][1]++;
  }

  cov_2gk9rxuhw8.s[4]++;
  $deltaLocation.addController($scope);
  var PATH = (cov_2gk9rxuhw8.s[5]++, 'Indicateurs');
  cov_2gk9rxuhw8.s[6]++;
  $scope.getIndicateurLabel = function (item) {
    cov_2gk9rxuhw8.f[1]++;
    cov_2gk9rxuhw8.s[7]++;

    if (!item.lie) {
      cov_2gk9rxuhw8.b[1][0]++;
      cov_2gk9rxuhw8.s[8]++;

      return item.li;
    } else {
      cov_2gk9rxuhw8.b[1][1]++;
    }
    cov_2gk9rxuhw8.s[9]++;
    if (item.lie.trim() == '') {
      cov_2gk9rxuhw8.b[2][0]++;
      cov_2gk9rxuhw8.s[10]++;

      return item.li;
    } else {
      cov_2gk9rxuhw8.b[2][1]++;
    }

    cov_2gk9rxuhw8.s[11]++;
    if (!item.li) {
      cov_2gk9rxuhw8.b[3][0]++;
      cov_2gk9rxuhw8.s[12]++;

      return item.lie;
    } else {
      cov_2gk9rxuhw8.b[3][1]++;
    }
    cov_2gk9rxuhw8.s[13]++;
    if (item.li.trim() == '') {
      cov_2gk9rxuhw8.b[4][0]++;
      cov_2gk9rxuhw8.s[14]++;

      return item.lie;
    } else {
      cov_2gk9rxuhw8.b[4][1]++;
    }

    cov_2gk9rxuhw8.s[15]++;
    if ($rootScope.language.id == 'en') {
      cov_2gk9rxuhw8.b[5][0]++;
      cov_2gk9rxuhw8.s[16]++;

      return item.lie;
    } else {
      cov_2gk9rxuhw8.b[5][1]++;
    }
    cov_2gk9rxuhw8.s[17]++;
    return item.li;
  };
  cov_2gk9rxuhw8.s[18]++;
  $scope.frameresult = {
    keyindic: true,
    plangeo: true,
    searchindic: '',
    listTypeIndic: [],
    socio: false,
    data: [],
    isloading: true,
    spacial: false,
    years: [],
    typeindic: null,
    lastindex: null,
    dataChart: [],
    lineOptions: {
      scaleShowGridLines: true,
      scaleGridLineColor: 'rgba(0,0,0,.05)',
      scaleGridLineWidth: 1,
      bezierCurve: true,
      bezierCurveTension: 0.4,
      pointDot: true,
      pointDotRadius: 4,
      pointDotStrokeWidth: 1,
      pointHitDetectionRadius: 20,
      datasetStroke: true,
      datasetStrokeWidth: 2,
      datasetFill: false,
      responsive: true
    },

    lineOptions_std: {
      scaleShowGridLines: true,
      scaleGridLineColor: 'rgba(0,0,0,.05)',
      scaleGridLineWidth: 1,
      bezierCurve: true,
      bezierCurveTension: 0.4,
      pointDot: true,
      pointDotRadius: 4,
      pointDotStrokeWidth: 1,
      pointHitDetectionRadius: 20,
      datasetStroke: true,
      datasetStrokeWidth: 2,
      datasetFill: false,
      responsive: true
    },

    location: { id: 0 },
    printsheet: function printsheet() {
      cov_2gk9rxuhw8.s[19]++;

      window.print();
    },
    filterList: function filterList(item) {
      cov_2gk9rxuhw8.s[20]++;

      if ((cov_2gk9rxuhw8.b[7][0]++, $scope.frameresult.typeindic.id > 0) && (cov_2gk9rxuhw8.b[7][1]++, item.ti != $scope.frameresult.typeindic.id)) {
        cov_2gk9rxuhw8.b[6][0]++;
        cov_2gk9rxuhw8.s[21]++;

        return false;
      } else {
        cov_2gk9rxuhw8.b[6][1]++;
      }
      cov_2gk9rxuhw8.s[22]++;
      if ((cov_2gk9rxuhw8.b[9][0]++, $scope.frameresult.typeindic.id == -1) && (cov_2gk9rxuhw8.b[9][1]++, item.sp == 0)) {
        cov_2gk9rxuhw8.b[8][0]++;
        cov_2gk9rxuhw8.s[23]++;

        return false;
      } else {
        cov_2gk9rxuhw8.b[8][1]++;
      }
      cov_2gk9rxuhw8.s[24]++;
      if ((cov_2gk9rxuhw8.b[11][0]++, $scope.frameresult.typeindic.id == -2) && (cov_2gk9rxuhw8.b[11][1]++, item.so == 0)) {
        cov_2gk9rxuhw8.b[10][0]++;
        cov_2gk9rxuhw8.s[25]++;

        return false;
      } else {
        cov_2gk9rxuhw8.b[10][1]++;
      }
      cov_2gk9rxuhw8.s[26]++;
      if ((cov_2gk9rxuhw8.b[13][0]++, $scope.frameresult.keyindic.id == -3) && (cov_2gk9rxuhw8.b[13][1]++, item.key == 0)) {
        cov_2gk9rxuhw8.b[12][0]++;
        cov_2gk9rxuhw8.s[27]++;

        return false;
      } else {
        cov_2gk9rxuhw8.b[12][1]++;
      }
      cov_2gk9rxuhw8.s[28]++;
      if ($scope.frameresult.searchindic.length != 0) {
        cov_2gk9rxuhw8.b[14][0]++;

        var re = (cov_2gk9rxuhw8.s[29]++, $scope.frameresult.searchindic.toUpperCase());
        cov_2gk9rxuhw8.s[30]++;
        if (item.in.toUpperCase().replace(re, '') == item.in.toUpperCase()) {
          cov_2gk9rxuhw8.b[15][0]++;
          cov_2gk9rxuhw8.s[31]++;

          return false;
        } else {
          cov_2gk9rxuhw8.b[15][1]++;
        }
      } else {
        cov_2gk9rxuhw8.b[14][1]++;
      }
      cov_2gk9rxuhw8.s[32]++;
      return true;
    },
    changeColor: function changeColor() {
      var color = (cov_2gk9rxuhw8.s[33]++, $rootScope.personalData);
      cov_2gk9rxuhw8.s[34]++;
      this.dataChart = {
        labels: [],
        datasets: [{
          label: $translate.instant('INDICATOR.REF'),
          fillColor: 'rgba(' + color.rframeVR + ',0.5)',
          strokeColor: 'rgba(' + color.rframeVR + ',0.7)',
          pointColor: 'rgba(' + color.rframeVR + ',1)',
          pointStrokeColor: '#fff',
          pointHighlightFill: '#fff',
          pointHighlightStroke: 'rgba(' + color.rframeVR + ',1)',
          data: []
        }, {
          label: $translate.instant('INDICATOR.REAL_VAL'),
          fillColor: 'rgba(' + color.rframeV + ',0.5)',
          strokeColor: 'rgba(' + color.rframeV + ',0.7)',
          pointColor: 'rgba(' + color.rframeV + ',1)',
          pointStrokeColor: '#fff',
          pointHighlightFill: '#fff',
          pointHighlightStroke: 'rgba(' + color.rframeV + ',1)',
          data: []
        }, {
          label: $translate.instant('INDICATOR.TARGET'),
          fillColor: 'rgba(' + color.rframeVC + ',0.5)',
          strokeColor: 'rgba(' + color.rframeVC + ',0.7)',
          pointColor: 'rgba(' + color.rframeVC + ',1)',
          pointStrokeColor: '#fff',
          pointHighlightFill: '#fff',
          pointHighlightStroke: 'rgba(' + color.rframeVC + ',1)',
          data: []
        }]
      };

      cov_2gk9rxuhw8.s[35]++;
      this.dataChart_Second = {
        labels: [],
        datasets: [{
          label: $translate.instant('INDICATOR.TARGET_VAL'),
          fillColor: 'rgba(' + color.rframeVD + ',0.5)',
          strokeColor: 'rgba(' + color.rframeVD + ',0.7)',
          pointColor: 'rgba(' + color.rframeVD + ',1)',
          pointStrokeColor: '#fff',
          pointHighlightFill: '#fff',
          pointHighlightStroke: 'rgba(' + color.rframeVD + ',1)',
          data: []
        }, {
          label: $translate.instant('INDICATOR.REAL_VAL'),
          fillColor: 'rgba(' + color.rframeV + ',0.5)',
          strokeColor: 'rgba(' + color.rframeV + ',0.7)',
          pointColor: 'rgba(' + color.rframeV + ',1)',
          pointStrokeColor: '#fff',
          pointHighlightFill: '#fff',
          pointHighlightStroke: 'rgba(' + color.rframeV + ',1)',
          data: []
        }]
      };

      cov_2gk9rxuhw8.s[36]++;
      this.flotData = [{
        label: $translate.instant('INDICATOR.TARGET_VAL'),
        grow: { stepMode: 'linear' },
        data: [],
        color: 'rgba(' + color.rframeVR + ',0.7)',
        bars: {
          show: true,
          align: 'center',
          barWidth: 24 * 60 * 60 * 600,
          lineWidth: 0
        }

      }, {
        label: $translate.instant('INDICATOR.REAL_VAL'),
        grow: { stepMode: 'linear' },
        data: [],
        yaxis: 2,
        color: 'rgba(' + color.rframeVD + ',0.7)',
        lines: {
          lineWidth: 1,
          show: true,
          fill: true,
          fillColor: {
            colors: [{
              opacity: 0.2
            }, {
              opacity: 0.2
            }]
          }
        }
      }];
    },
    process: function process(item) {
      cov_2gk9rxuhw8.s[37]++;

      this.location = (cov_2gk9rxuhw8.b[16][0]++, item) || (cov_2gk9rxuhw8.b[16][1]++, { id: 0 });
      cov_2gk9rxuhw8.s[38]++;
      this.isloading = true;
      cov_2gk9rxuhw8.s[39]++;
      this.years = [];
      cov_2gk9rxuhw8.s[40]++;
      this.lastindex = null;
      cov_2gk9rxuhw8.s[41]++;
      this.searchindic = '';
      cov_2gk9rxuhw8.s[42]++;
      $CRUDService.getAll(PATH, { get: 'frameres', idl: this.location.id }, function (data) {
        cov_2gk9rxuhw8.f[2]++;

        var initD = (cov_2gk9rxuhw8.s[43]++, data.d[0]);
        cov_2gk9rxuhw8.s[44]++;
        if (initD) {
          cov_2gk9rxuhw8.b[17][0]++;
          cov_2gk9rxuhw8.s[45]++;

          for (var el in initD) {
            cov_2gk9rxuhw8.s[46]++;

            try {
              cov_2gk9rxuhw8.s[47]++;

              if (eval(el)) {
                cov_2gk9rxuhw8.b[18][0]++;
                cov_2gk9rxuhw8.s[48]++;

                $scope.frameresult.years.push(el);
              } else {
                cov_2gk9rxuhw8.b[18][1]++;
              }
            } catch (e) {
              cov_2gk9rxuhw8.s[49]++;

              continue;
            }
          }
        } else {
          cov_2gk9rxuhw8.b[17][1]++;
        }
        cov_2gk9rxuhw8.s[50]++;
        $scope.frameresult.isloading = false;

        cov_2gk9rxuhw8.s[51]++;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = data.d[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _el = _step.value;
            cov_2gk9rxuhw8.s[52]++;

            if ((cov_2gk9rxuhw8.b[20][0]++, _el.t == 1) || (cov_2gk9rxuhw8.b[20][1]++, _el.t == 2)) {
              cov_2gk9rxuhw8.b[19][0]++;
              cov_2gk9rxuhw8.s[53]++;

              _el.vra = $filter('number')(eval(_el.vr), _el.fo);
              cov_2gk9rxuhw8.s[54]++;
              _el.vca = $filter('number')(eval(_el.vc), _el.fo);
              cov_2gk9rxuhw8.s[55]++;
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = $scope.frameresult.years[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var year = _step2.value;
                  cov_2gk9rxuhw8.s[56]++;

                  _el[year + 'a'] = $filter('number')(eval(_el[year]), _el.fo);
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            } else {
              cov_2gk9rxuhw8.b[19][1]++;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        cov_2gk9rxuhw8.s[57]++;
        $scope.frameresult.data = data;
      });
    },
    closeChart: function closeChart(index) {
      cov_2gk9rxuhw8.s[58]++;

      $('[data-toggle="popover_' + index + '"]').popover('hide');
    },
    openChart: function openChart(item) {
      cov_2gk9rxuhw8.s[59]++;

      // if(this.lastindex!==null) this.closeChart(this.lastindex);
      if (this.lastindex == item.id) {
        cov_2gk9rxuhw8.b[21][0]++;
        cov_2gk9rxuhw8.s[60]++;

        this.lastindex = null;
        cov_2gk9rxuhw8.s[61]++;
        return;
      } else {
        cov_2gk9rxuhw8.b[21][1]++;
      }
      cov_2gk9rxuhw8.s[62]++;
      this.lastindex = item.id;

      var cible = (cov_2gk9rxuhw8.s[63]++, item.vc);
      var ref = (cov_2gk9rxuhw8.s[64]++, item.vr);
      cov_2gk9rxuhw8.s[65]++;
      this.changeColor();

      cov_2gk9rxuhw8.s[66]++;
      this.dataChart.labels = [].concat($scope.frameresult.years);
      cov_2gk9rxuhw8.s[67]++;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.years[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var el = _step3.value;
          cov_2gk9rxuhw8.s[68]++;

          this.dataChart.datasets[0].data.push(ref);
          cov_2gk9rxuhw8.s[69]++;
          this.dataChart.datasets[1].data.push((cov_2gk9rxuhw8.b[22][0]++, eval(item[el])) || (cov_2gk9rxuhw8.b[22][1]++, undefined));

          cov_2gk9rxuhw8.s[70]++;
          this.dataChart_Second.datasets[1].data.push((cov_2gk9rxuhw8.b[23][0]++, eval(item['P' + el])) || (cov_2gk9rxuhw8.b[23][1]++, undefined));
          cov_2gk9rxuhw8.s[71]++;
          this.dataChart_Second.datasets[0].data.push((cov_2gk9rxuhw8.b[24][0]++, eval(item[el])) || (cov_2gk9rxuhw8.b[24][1]++, undefined));

          cov_2gk9rxuhw8.s[72]++;
          this.dataChart.datasets[2].data.push(cible);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      cov_2gk9rxuhw8.s[73]++;
      this.customGraphe.firstChart = this.customGraphe.process(this.dataChart.datasets);
      cov_2gk9rxuhw8.s[74]++;
      this.customGraphe.secondChart = this.customGraphe.process(this.dataChart_Second.datasets, true);
      // this.customGraphe.secondChart.color=["rgba("+color.rframeVD+",0.7)","rgba("+color.rframeVC+",0.7)"];
    },

    customGraphe: {
      process: function process(dataSet, withbg) {
        cov_2gk9rxuhw8.s[75]++;

        return {
          data: this.__getData(dataSet),
          series: this.__getSerie(dataSet),
          color: this.__getColor(dataSet),
          option: this.__getOption(withbg),
          data_override: this.__getDataOverride()
        };
      },
      process_donut: function process_donut(prevu, real) {
        cov_2gk9rxuhw8.s[76]++;

        this.data_donut = [[], []];
        cov_2gk9rxuhw8.s[77]++;
        this.color_donut = [];
        cov_2gk9rxuhw8.s[78]++;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = prevu[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var el = _step4.value;
            cov_2gk9rxuhw8.s[79]++;

            this.data_donut[0].push(el.value);
            cov_2gk9rxuhw8.s[80]++;
            this.color_donut.push(el.color);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        cov_2gk9rxuhw8.s[81]++;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = real[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _el2 = _step5.value;
            cov_2gk9rxuhw8.s[82]++;

            this.data_donut[1].push(_el2.value);
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      },
      __getData: function __getData(dataSet) {
        var data = (cov_2gk9rxuhw8.s[83]++, []);
        cov_2gk9rxuhw8.s[84]++;
        for (var el in dataSet) {
          cov_2gk9rxuhw8.s[85]++;

          data.push(dataSet[el].data);
        }

        cov_2gk9rxuhw8.s[86]++;
        return data;
      },
      __getSerie: function __getSerie(dataSet) {
        var data = (cov_2gk9rxuhw8.s[87]++, []);
        cov_2gk9rxuhw8.s[88]++;
        for (var el in dataSet) {
          cov_2gk9rxuhw8.s[89]++;

          data.push(dataSet[el].label);
        }
        cov_2gk9rxuhw8.s[90]++;
        return data;
      },
      __getColor: function __getColor(dataSet) {
        var data = (cov_2gk9rxuhw8.s[91]++, []);
        cov_2gk9rxuhw8.s[92]++;
        for (var el in dataSet) {
          cov_2gk9rxuhw8.s[93]++;

          data.push(dataSet[el].strokeColor);
        }
        cov_2gk9rxuhw8.s[94]++;
        return data;
      },
      __getOption: function __getOption(withbg) {
        cov_2gk9rxuhw8.s[95]++;

        return {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          },
          animation: {
            onComplete: function onComplete() {
              var ctx = (cov_2gk9rxuhw8.s[96]++, this.chart.ctx);
              cov_2gk9rxuhw8.s[97]++;
              ctx.textAlign = 'center';
              cov_2gk9rxuhw8.s[98]++;
              ctx.textBaseline = 'bottom';
              var dataset = (cov_2gk9rxuhw8.s[99]++, this.chart.config.data.datasets[withbg ? (cov_2gk9rxuhw8.b[25][0]++, 0) : (cov_2gk9rxuhw8.b[25][1]++, 1)]);
              cov_2gk9rxuhw8.s[100]++;
              ctx.fillStyle = '#676a6c';
              cov_2gk9rxuhw8.s[101]++;
              for (var numdata in dataset._meta) {
                var oncompletdata = (cov_2gk9rxuhw8.s[102]++, dataset._meta[numdata]);
                cov_2gk9rxuhw8.s[103]++;
                oncompletdata.data.forEach(function (p) {
                  cov_2gk9rxuhw8.f[3]++;
                  cov_2gk9rxuhw8.s[104]++;

                  ctx.fillText(p._chart.config.data.datasets[p._datasetIndex].data[p._index], p._model.x, p._model.y - 10);
                });
                cov_2gk9rxuhw8.s[105]++;
                break;
              }
            }
          },
          maintainAspectRatio: false,
          elements: {
            line: {
              fill: Boolean(withbg),
              cubicInterpolationMode: 'monotone',
              spanGaps: false,
              tension: 0
            }
          }
        };
      },
      __getDataOverride: function __getDataOverride() {
        cov_2gk9rxuhw8.s[106]++;

        return [{
          label: $translate.instant('INDICATOR.REAL_VAL'),
          borderWidth: 3,

          type: 'line'
        }, {
          label: $translate.instant('INDICATOR.TARGET_VAL'),
          borderWidth: 1,
          type: 'bar'
        }];
      }
    }
  };

  cov_2gk9rxuhw8.s[107]++;
  $deltaTypeIndicateur.addController($scope, function () {
    cov_2gk9rxuhw8.f[4]++;
    cov_2gk9rxuhw8.s[108]++;

    $scope.frameresult.listTypeIndic = [{
      ID_PROJET: 0,
      LIBELLE_TI: $translate.instant('COMMON.ALL'),
      NUM_COULEUR_INDIC: '0,0,0',
      id: '0'
    }, {
      ID_PROJET: 0,
      LIBELLE_TI: $translate.instant('INDICATOR.KEY_KPI'),
      NUM_COULEUR_INDIC: '0,0,0',
      id: '-3'
    }, {
      ID_PROJET: 0,
      LIBELLE_TI: $translate.instant('INDICATOR.SPATIAL'),
      NUM_COULEUR_INDIC: '0,0,0',
      id: '-1'
    }, {
      ID_PROJET: 0,
      LIBELLE_TI: $translate.instant('INDICATOR.SOCIO_ECO'),
      NUM_COULEUR_INDIC: '0,0,0',
      id: '-2'
    }].concat($scope.listData_TypeIndicateur_bksb);
    cov_2gk9rxuhw8.s[109]++;
    $scope.frameresult.typeindic = $scope.frameresult.listTypeIndic[$scope.frameresult.listTypeIndic.length - 1];
  });
  cov_2gk9rxuhw8.s[110]++;
  $scope.frameresult.process();
});